// App.js
import React from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation, useNavigationType } from 'react-router-dom';
import HomePage from './pages/HomePage';
import Header from './components/Header';
import Footer from './components/Footer';
import BlueprintBg from './components/BlueprintBg';
import Company from './pages/Company';
import Portfolio from './pages/Portfolio';
import PortfolioDetail from './pages/PortfolioDetail';
import Board from './pages/Board';
import BoardDetail from './pages/BoardDetail';
import BoardWrite from './pages/BoardWrite';
import PortfolioWrite from './pages/PortfolioWrite';
import Contact from './pages/Contact';
import { AuthProvider } from './contexts/AuthContext';
import './styles/tokens.css';
import './styles/components.css';
import './styles/index.css';
import './styles/style.css';
import './styles/pretendard.css';
import BoardEdit from './pages/BoardEdit';
import PortfolioEdit from './pages/PortfolioEdit';
import Services from './pages/Services';
import MeetingTimer from './pages/MeetingTimer';
import Roulette from './pages/Roulette';
import Insights from './pages/Insights';
import InsightPlanning from './pages/InsightPlanning';
import InsightCost from './pages/InsightCost';
import InsightAppDev from './pages/InsightAppDev';
import InsightOutsourcing from './pages/InsightOutsourcing';
import InsightMaintenance from './pages/InsightMaintenance';
import Privacy from './pages/Privacy';

// 메뉴로 페이지를 옮기면 직전 스크롤 위치가 남아 본문 중간부터 보이는 문제가 있어,
// 경로가 바뀔 때 최상단으로 올린다.
// - #앵커가 있으면 그 위치로 가야 하므로 건너뛴다.
// - 뒤로/앞으로 가기(POP)는 브라우저의 스크롤 복원에 맡긴다.
function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  React.useEffect(() => {
    if (hash || navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, hash, navigationType]);

  return null;
}

// 헤더/푸터를 감싸는 레이아웃.
// - 홈: 히어로가 헤더 아래까지 차오르도록 flush
// - /roulette: 전체화면 게임이라 헤더/푸터/오프셋 없이 단독 렌더
function AppShell() {
  const location = useLocation();
  const path = location.pathname;
  const isHome = path === '/';
  const chromeless = path.startsWith('/roulette');

  return (
    <div className="App">
      <ScrollToTop />
      {!chromeless && <BlueprintBg />}
      {!chromeless && <Header />}
      <main className={chromeless ? 'app-fullbleed' : `site-main${isHome ? ' site-main--flush' : ''}`}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/company" element={<Company />} />
          <Route path="/services" element={<Services />} />
          <Route path="/board" element={<Board />} />
          <Route path="/board/:id" element={<BoardDetail />} />
          <Route path="/board/write" element={<BoardWrite />} />
          <Route path="/board/edit/:id" element={<BoardEdit />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/portfolio/:id" element={<PortfolioDetail />} />
          <Route path="/portfolio/write" element={<PortfolioWrite />} />
          <Route path="/portfolio/edit/:id" element={<PortfolioEdit />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/planning" element={<InsightPlanning />} />
          <Route path="/insights/cost" element={<InsightCost />} />
          <Route path="/insights/app-development" element={<InsightAppDev />} />
          <Route path="/insights/outsourcing" element={<InsightOutsourcing />} />
          <Route path="/insights/maintenance" element={<InsightMaintenance />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/meeting-timer" element={<MeetingTimer />} />
          <Route path="/roulette" element={<Roulette />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!chromeless && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppShell />
      </Router>
    </AuthProvider>
  );
}

export default App;
